import c from '../common';

export default{

    "invisibleText": "已隱藏",
    "visibleText": "已開放給任何人看",

    "ChangeData": "修改商戶資料",

    "AppVisibility": "在手機App上",
    "visible": "可見",
    "invisible": "不可見",

    //Col of await approval
    "AwaitApproval" : "正在等待審核",
    "AwaitText": "您可以在等待審核時隨時編輯所有信息。",

    //Need modification
    "NeedModify": "需要修改資料,並重新提交",
    
    //Badge of detail status
    "CurrentData": "現時資料",
    "UnapproveData": "尚未審核的資料",

    //Pending Detail Tab
    "NA": "暫無",

    text1: "查看上次更改記錄",
    text2: "暫無資料",
    text3: "您沒有相應權限",
    text4: "錯誤",
    text5: "動作",
    text6: "顯示",
    text7: "隱藏",
    text8: "商店",
    text9: "時間",
};